import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, StringField, Int32Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class WclapParameterBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new WclapParameterBox({
            uuid,
            graph,
            name: "WclapParameterBox",
            pointerRules: NoPointers,
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "WclapParameterBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitWclapParameterBox, this);
    }
    get tags() {
        return WclapParameterBox.Tags;
    }
    get owner() {
        return this.getField(1);
    }
    get label() {
        return this.getField(2);
    }
    get clapId() {
        return this.getField(3);
    }
    get value() {
        return this.getField(4);
    }
    get defaultValue() {
        return this.getField(5);
    }
    get min() {
        return this.getField(6);
    }
    get max() {
        return this.getField(7);
    }
    get flags() {
        return this.getField(8);
    }
    get module() {
        return this.getField(9);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "owner",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.Parameter, true),
            2: StringField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }, ""),
            3: Int32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "clapId",
                deprecated: false,
                pointerRules: NoPointers,
            }, "any", ""),
            4: Float32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "value",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "any", ""),
            5: Float32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "defaultValue",
                deprecated: false,
                pointerRules: NoPointers,
            }, "any", ""),
            6: Float32Field.create({
                parent: this,
                fieldKey: 6,
                fieldName: "min",
                deprecated: false,
                pointerRules: NoPointers,
            }, "any", ""),
            7: Float32Field.create({
                parent: this,
                fieldKey: 7,
                fieldName: "max",
                deprecated: false,
                pointerRules: NoPointers,
            }, "any", ""),
            8: Int32Field.create({
                parent: this,
                fieldKey: 8,
                fieldName: "flags",
                deprecated: false,
                pointerRules: NoPointers,
            }, "any", ""),
            9: StringField.create({
                parent: this,
                fieldKey: 9,
                fieldName: "module",
                deprecated: false,
                pointerRules: NoPointers,
            }, ""),
        };
    }
}
